import { Outlet } from "react-router-dom";

const InstitutionsPageLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default InstitutionsPageLayout;